import { FormControl, Grid, Typography } from "@mui/material";
import { VerticalAlignGrid } from "../../../invoices/styled";

interface Props {
  label: string;
  labelWidth?: number;
  labelColor?: string;
  value: any;
  valueWidth?: number;
}

const DEFAULT_LABEL_WIDTH = 3;
const DEFAULT_VALUE_WIDTH = 5;

const LabelValueRow = ({
  label,
  labelWidth = DEFAULT_LABEL_WIDTH,
  labelColor,
  value,
  valueWidth = DEFAULT_VALUE_WIDTH,
}: Props) => {
  return (
    <VerticalAlignGrid container spacing={1}>
      <Grid
        container
        item
        xs={labelWidth}
        justifyContent="flex-end"
        paddingRight="0.5rem"
      >
        <Typography variant="secondary" color={labelColor}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={valueWidth}>
        <FormControl fullWidth size="small">
          <Typography>{value}</Typography>
        </FormControl>
      </Grid>
    </VerticalAlignGrid>
  );
};

export default LabelValueRow;
